import { Autocomplete } from "@mui/lab";
import { TextField } from "@mui/material";
import { FieldError } from "react-hook-form";

export const inquiryStatus = [
	{
		code: "O",
		name: "Open",
	},
	{
		code: "C",
		name: "Closed",
	},
	{
		code: "I",
		name: "Inquire",
	},
	{
		code: "PI",
		name: "Place holder / Inquire",
	},
	{
		code: "PS",
		name: "Planned Stock",
	},
];

type Props = {
	label?: string;
	value: string | null;
	readOnly?: boolean;
	onChange?: Function;
	fieldError?: FieldError | undefined;
	disabled?: boolean;
	required?: boolean;
};

export const InquiryStatusSelector = ({
	label = "Inquiry Status",
	value,
	readOnly = false,
	onChange = () => {},
	fieldError,
	disabled = false,
	required = false,
}: Props) => {
	const selectedType =
		inquiryStatus.find((code) => code.code === value) || inquiryStatus[0];

	return (
		<Autocomplete
			id="event-type-selector"
			clearOnEscape
			autoHighlight
			disableClearable
			options={inquiryStatus}
			getOptionLabel={(option) => option.name}
			renderInput={(params) => (
				<TextField
					{...params}
					inputProps={{
						...params.inputProps,
						"data-test-id": "inquiry-status-selector",
					}}
					required={required}
					label={label}
					aria-readonly={readOnly}
					fullWidth
					error={!!fieldError}
					helperText={fieldError?.message}
					margin="none"
					size="small"
				/>
			)}
			value={selectedType}
			onChange={(event, newValue) => {
				onChange(newValue?.code ?? null);
			}}
			disabled={disabled}
		/>
	);
};
